/**
 * @fileoverview GET handler for the "/product_alerts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { productAlerts } from "./constants";
import type { ProductAlertsParams, ProductAlertsResult } from "./types";
import { isProductAlertsResult } from "./validators";

const serializeProductAlertsQuery = (
  query: NonNullable<ProductAlertsParams["query"]>
): Record<string, string | string[]> => {
  return {
    ...(query.name !== undefined ? { name: query.name } : {}),
    ...(query.status !== undefined ? { status: query.status } : {}),
    ...(query.canvas_ids !== undefined ? { canvas_ids: query.canvas_ids } : {}),
    ...(query.target !== undefined ? { target: query.target } : {}),
  };
};

export const getProductAlerts = reactQueryFetcherAdapter(
  productAlerts,
  (
    signal: AbortSignal,
    { query, start = 0, limit = 20, sortby, sortdir }: ProductAlertsParams
  ): Promise<ProductAlertsResult> => {
    return fetch(
      "/product_alerts",
      "GET",
      {
        start,
        limit,
        sortby,
        sortdir,
        ...(query ? { query: serializeProductAlertsQuery(query) } : {}),
      },
      { signal }
    );
  },
  isProductAlertsResult
);
